<template>
  <v-container id="inferenceSetting" fluid tag="section">
    <v-card>
      <v-row justify="center">
        <v-col cols="12">
          <v-tabs background-color="primary" v-model="currentTab" dark centered>
            <v-tabs-slider></v-tabs-slider>

            <v-tab href="#inference">
              {{ $t("inference") }}
              <v-icon>mdi-pipe</v-icon>
            </v-tab>

            <v-tab href="#fence">
              {{ $t("fence") }}
              <v-icon>mdi-wall</v-icon>
            </v-tab>
          </v-tabs>
        </v-col>

        <v-col cols="10">
          <v-tabs-items v-model="currentTab">
            <v-tab-item value="inference">
              <v-card flat>
                <InferenceInference></InferenceInference>
              </v-card>
            </v-tab-item>

            <v-tab-item value="fence">
              <v-card flat>
                <InferenceFence></InferenceFence>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import InferenceInference from "@/components/inference/InferenceInference.vue";
import InferenceFence from "@/components/inference/InferenceFence.vue";

export default {
  name: "InferenceSetting",
  components: {
    InferenceInference,
    InferenceFence,
  },
  data() {
    return {
      isCreate: true,
      tabTypes: ["inference", "fence"],
      currentTab: "inference",
    };
  },
  created() {
    let inference_camera_uuid = this.$route.params.uuid;

    this.isCreate = inference_camera_uuid == undefined ? true : false;

    if (sessionStorage.getItem("inferenceTab") != null) {
      this.currentTab = sessionStorage.getItem("inferenceTab");
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem("inferenceTab");
  },
  watch: {
    currentTab() {
      sessionStorage.setItem("inferenceTab", this.currentTab);
    },
  },
};
</script>
